import type { FragmentType } from 'src/gql';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { useState } from 'react';
import { UpdateType } from 'src/constants/portfolio';
import { graphql, unmaskFragment } from 'src/gql';

import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';

import { NetWorthItemMenu } from './views/net-worth-item-menu';

export const NetWorthAccountMenuFragment = graphql(/* GraphQL */ `
  fragment NetWorthAccountMenu on Account {
    custody
    id
    hiddenFromClient
    hiddenFromNetWorth
  }
`);

const UPDATE_ACCOUNT = graphql(/* GraphQL */ `
  mutation UpdateAccountFromNetWorthAccountItemMenu($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      account {
        id
      }
    }
  }
`);

export function NetWorthAccountMenu({
  advisorView,
  accountFrag,
  onEdit,
}: {
  readonly advisorView?: boolean;
  readonly accountFrag: FragmentType<typeof NetWorthAccountMenuFragment>;
  readonly onEdit: Deprecated_HandleItemUpdate;
}) {
  const account = unmaskFragment(NetWorthAccountMenuFragment, accountFrag);
  const [updateAccount] = useMutationWithErrorLogging(UPDATE_ACCOUNT);
  const [hiddenFromNetWorth, setHiddenFromNetWorth] = useState(!!account.hiddenFromNetWorth);
  const [hiddenFromClient, setHiddenFromClient] = useState(!!account.hiddenFromClient);

  async function handleChange(field: 'hiddenFromNetWorth' | 'hiddenFromClient', value: boolean) {
    const updateType = UpdateType.SHOW_HIDE_NET_WORTH;

    await updateAccount({
      variables: {
        input: {
          id: account.id,
          [field]: !value,
        },
      },
    });

    await onEdit({
      type: updateType,
      id: account.id,
    });
  }

  return (
    <NetWorthItemMenu
      advisorView={advisorView}
      hiddenFromClient={hiddenFromClient}
      hiddenFromNetWorth={hiddenFromNetWorth}
      isManagedAccount={account.custody === 'managed'}
      handleChange={handleChange}
      setHiddenFromClient={setHiddenFromClient}
      setHiddenFromNetWorth={setHiddenFromNetWorth}
    />
  );
}
